export { default } from "./UniversalSearchInput";
